import { LocalDate } from '@js-joda/core';

import { useBoolean } from '@dreryk/react-common';

import { protectFeature } from '~libs.shared.system';

import { InvoiceCreateModal } from './InvoiceCreateModal';
import { InvoiceCreateModalLoader } from './InvoiceCreateModal.loader';

type InvoiceCreateModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type InvoiceCreateModalOpenerProps = {
   patientId: number;
   visitDate: LocalDate;
   appointmentId: number;
   visitSettlementId: number;
   children: (renderProps: InvoiceCreateModalOpenerRenderProps) => JSX.Element | null;
};

export const InvoiceCreateModalOpener = (props: InvoiceCreateModalOpenerProps): JSX.Element | null => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return protectFeature(
      'creatingInvoices',
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? (
            <InvoiceCreateModalLoader referenceId={props.visitSettlementId.toString()}>
               {({ fiscalDocuments, fiscalPrintEnabled }) => (
                  <InvoiceCreateModal
                     onClose={closeModal}
                     patientId={props.patientId}
                     visitDate={props.visitDate}
                     appointmentId={props.appointmentId}
                     visitSettlementId={props.visitSettlementId}
                     fiscalDocuments={fiscalDocuments}
                     fiscalPrintEnabled={fiscalPrintEnabled}
                  />
               )}
            </InvoiceCreateModalLoader>
         ) : null}
      </>,
      null
   );
};
